module.exports = __webpack_public_path__ + "img/banner-dex-cloud.44f0b122.webp";